module.exports = __webpack_public_path__ + "img/fire-gce373e1ee_640.f1d315e2.jpg";